export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11016.a05c878d.jpg";